import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/shared/stores/auth'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './icons'
import '@fontsource-variable/inter'
import './styles/main.scss'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.component('FaIcon', FontAwesomeIcon)

// Hydrate auth state before mounting so guards can run on first navigation.
useAuthStore()
    .refresh()
    .finally(() => app.mount('#app'))
